import React from 'react';
import { Kpi } from '@zurich-data-dsm-charts/kpi';
import { ReactComponent as CloudIcon } from 'app/assets/Icons/Chips/Cloud.svg';
import styles from './KpiCard.module.scss';
import { IKpiCard } from './KpiCard.interface';
import { Info } from '@zurich-data-dsm-icons/communication.info';
import { Tooltip } from 'react-tooltip';

export const KpiCard: React.FC<IKpiCard> = ({
  title,
  mainLabel,
  mainData,
  percentageDifference,
  tooltipContent
}) => {
  return (
    <>
      <div className={styles['kpi-card']}>
        <div className={styles['kpi-header']}>
          <div className={styles['kpi-title']}>
            <CloudIcon />
            <p>{title}</p>
          </div>

          {tooltipContent && (
            <div className={styles['kpi-info']}>
              <p
                data-tooltip-id="kpi-info-tooltip"
                data-tooltip-content={tooltipContent}
              >
                <Info />
              </p>

              <Tooltip
                id="kpi-info-tooltip"
                className={styles['kpi-info-tooltip']}
              />
            </div>
          )}
        </div>
        <Kpi>
          <div className={styles['kpi-main']}>
            <Kpi.Main>
              <Kpi.Main.Data>{mainData}</Kpi.Main.Data>
              <p className={styles.label}>{mainLabel}</p>
            </Kpi.Main>
          </div>
          <Kpi.Diff>
            <div className={styles['kpi-diff']}>
              <Kpi.Diff.Percentage>
                {percentageDifference.toFixed(2)}
              </Kpi.Diff.Percentage>
            </div>
            <Kpi.Diff.Label>previous month</Kpi.Diff.Label>
          </Kpi.Diff>
        </Kpi>
      </div>
    </>
  );
};
